import axios from "axios";
const jsonConfig = require("../Config.json");

const fetchCountryStateCity = async (payLoad) => {
    try {

        const response = await axios.post(
            `${jsonConfig.apiUrl}fetch-country-state-city`, payLoad,
            {
                headers: {
                    "x-functions-key": jsonConfig.key,
                },
            }
        );
        return Promise.resolve(response);
    }
    catch (error) {
        return Promise.reject(error);
    }
}

export default fetchCountryStateCity